import React from "react";
import * as Icon from "react-bootstrap-icons";
import * as Utils from "../../inc/Utils";
import {Link, NavLink} from "react-router-dom";
import Role from "../../inc/Role";
import toast, { Toaster } from 'react-hot-toast';

import Pagination from "react-js-pagination";
import DatePicker from "react-datepicker";
import {Config} from '../../Config'
import Select from 'react-select'
import {CopyToClipboard} from 'react-copy-to-clipboard';
import * as XLSX from "xlsx";
import ModalShortIO from "./ModalShortIO";
import ModalQRCode from "./ModalQRCode";
import * as AwsS3 from "../../inc/AwsS3";

export default function UtmGenerate() {
    const roles = new Role();
    //region search
    let btnTextDefault = 'ค้นหา';
    let btnTextLoading = 'กำลังค้นหา..';
    let [showSearch, setShowSearch] = React.useState(false);
    let [itemPerpage, setItemPerpage] = React.useState(10);
    let [countAllItem, setCountAllItem] = React.useState(0);
    let [activePage, setActivePage] = React.useState(1);
    let [totalPage, setTotalPage] = React.useState(0); 
    let [startDate, setStartDate] = React.useState(null);
    let [endDate, setEndDate] = React.useState(null);
    let [userId, setUserId] = React.useState(null);
    let [typeId, setTypeId] = React.useState(null);
    let [shortio, setShortIO] = React.useState(null);
    let [checkedIds, setCheckedIds] = React.useState([]);
    let [showModalForm, setShowModalForm] = React.useState(false);
    let [showModalQRCode, setShowModalQRCode] = React.useState(false);
    let [isUpdateSlug, setIsUpdateSlug] = React.useState(false);
    let [shortIOData, setShortIOData] = React.useState(null);
    let [shortIOUrl, setShortIOUrl] = React.useState('');
    let [qrcodeLogo, setQrcodeLogo] = React.useState(null);
    let [awsS3Config, setAwsS3Config] = React.useState([]);

    const onSearch = (e) => {
        e.preventDefault();
        getDataSearch({
            param : e.target.elements.param.value,
            startDate : startDate ?? null,
            endDate : endDate ?? null,
            createdBy : userId != null ? userId.id : null,
            typeId : typeId != null ? typeId.id : null,
        });
    };
    const onSearchReset = () => {
        setParam('');
        setUserId(null);
        setTypeId(null);
        setActivePage(0);
        getDataSearch({
            param : null,
            startDate : null,
            endDate : null,
            createdBy : null,
            typeId : null,
            activePage: 1
        });
    };
    const onChangeUsers = (obj) => setUserId(obj);
    const onChangeType = (obj) => setTypeId(obj);
    const onPageChange = (pageNum) => {
        setActivePage(pageNum);
        getDataSearch({
            param : param ?? null,
            startDate : startDate ?? null,
            endDate : endDate ?? null,
            createdBy : userId != null ? userId.id : null,
            typeId : typeId != null ? typeId.id : null,
            activePage: pageNum,
        });
    };
    //endregion

    let [isLoading, setLoading] = React.useState(false);
    let [data, setData] = React.useState('');
    let [users, setUsers] = React.useState('');
    let [type, setType] = React.useState('');
    let [param, setParam] = React.useState(null);

    React.useEffect(() => {
        (async function() {
            try {
                const resUsers = await getUsers();
                setUsers(resUsers);
                const resShortIO = await Utils.getShortio();
                setShortIO(resShortIO);
                const resType = await Utils.getType();
                setType(resType);
                const result = await getData({
                    startDate : null,
                    endDate : null,
                    createdBy: null,
                    typeId: null
                });
                setCountAllItem(result.count);
                setTotalPage(result.count > 0 ? (result.count / itemPerpage) : 1);
                setData(result.rows);

                let resLogo = await Utils.getQrcodeLogo();
                setQrcodeLogo(resLogo);
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, [isUpdateSlug]);

    async function getData(params) {
        setLoading(true);
        const response = await fetch(Config.url.API_URL +'/api/utmGenerate/listing', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                param : params.param ?? null,
                startDate : params.startDate ?? null,
                endDate : params.endDate ?? null,
                createdBy: params.createdBy ?? null,
                typeId: params.typeId ?? null,
                itemPerpage: itemPerpage,
                startItem: params.activePage > 1 ? (params.activePage*itemPerpage)-itemPerpage : 0,
                agencyId: roles.permissionId === Utils.SUPER_ADMIN_ID ? null : roles.agencyId
            })
        });

        setLoading(false);
        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getUsers() {
        const response = await fetch(Config.url.API_URL +'/api/user/listingName', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                agencyId: roles.permissionId === Utils.SUPER_ADMIN_ID ? null : roles.agencyId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const getDataSearch = (params) => {
        setLoading(true);
        if(params.itemPerpage) {
            itemPerpage = params.itemPerpage;
        }
        fetch(Config.url.API_URL +'/api/utmGenerate/listing', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                param : params.param ?? null,
                startDate : params.startDate ?? null,
                endDate : params.endDate ?? null,
                createdBy: params.createdBy ?? null,
                typeId: params.typeId ?? null,
                itemPerpage: itemPerpage,
                startItem: params.activePage > 1 ? (params.activePage*itemPerpage)-itemPerpage : 0,
                agencyId: roles.permissionId === Utils.SUPER_ADMIN_ID ? null : roles.agencyId
            })
        }).then(response => {
            setLoading(false);
            if(response.ok) {
                return response.json();
            }
            else {
                return response.json().then(err => Promise.reject(err));
            }
        }).then(result => {
            setCountAllItem(result.count);
            setTotalPage(result.count > 0 ? (result.count / itemPerpage) : 1);
            setData(result.rows);
        }).catch(err => {
            toast.error(err.message);
        });
    };

    const onChangeParam = (value) => setParam(value);
    const onChangeItemPerpage = (e) => {
        setItemPerpage(e.target.value);
        setActivePage(1);
        getDataSearch({
            param : null,
            startDate : null,
            endDate: null,
            createdBy: null,
            typeId: null,
            activePage: 1,
            itemPerpage: e.target.value
        });
    };
    const onChangeStartDate = (value) => {
        setStartDate(value);
        if(value > endDate) {
            setEndDate('');
        }
    };
    const onChangeEndDate = (value) => {
        setEndDate(value);
    };

    const onCopyFullUrl = () => {
        toast.success("คัดลอก Full URL แล้ว", {autoClose: 1000});
    };

    const onCopyRebrandlyUrl = () => {
        toast.success("คัดลอก Rebrandly Short URL แล้ว", {autoClose: 1000})
    };

    const onCopyShortIOUrl = () => {
        toast.success("คัดลอก Short.io Short URL แล้ว", {autoClose: 1000})
    };

    const onCheckAll = (isChecked) => {
        if(data.length) {
            data.map((row, index) => {
                let chkSourceId = 'checkId' + row.id;
                if(document.getElementById(chkSourceId)) {
                    document.getElementById(chkSourceId).checked = isChecked;
                }
            });
            onCheckedItem();
        }
    };

    const onCheckedItem = () => {
        let ids = [];
        if(data.length) {
            data.map(row => {
                let chkSourceId = 'checkId' + row.id;
                if(document.getElementById(chkSourceId) && document.getElementById(chkSourceId).checked) {
                    ids.push(row.id);
                }
            });
            setCheckedIds(ids);
        }
    };

    const onExportSelected = () => {
        if(checkedIds.length > 0) {
            let jsonData = [];
            if(data.length) {
                data.map(row => {
                    if(checkedIds.includes(row.id)) {
                        jsonData.push({
                            ID: row.id,
                            Type: Utils.generateUTMType(row.typeId),
                            URL: row.url,
                            Params: row.params,
                            FullURL: row.url+'?'+row.params,
                            Rebrandly: row.shortUrl ? row.shortUrl : '',
                            ShortIO: row.shortIO ? shortio.domain + '/' + row.shortIO : '',
                            CreatedBy: row.user.contact,
                            CreatedDate: Utils.dateYMDHI(row.createdAt)
                        });
                    }
                });
            }
            const worksheet = XLSX.utils.json_to_sheet(jsonData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
            XLSX.writeFile(workbook, "utmGenerate_Export_" + Utils.getDate() + ".xlsx");
        }
    };

    const onEditShortIO = (row) => {
        setShowModalForm(true);
        setShortIOData(row);
    };

    const handleModalFormUpdate = (flag) => {
        setIsUpdateSlug(flag);
    };

    const handleModalClose = () => {
        setShowModalForm(false);
        setShowModalQRCode(false);
        setShortIOData(null);
        getDataSearch({
            param : param ?? null,
            startDate : startDate ?? null,
            endDate : endDate ?? null,
            createdBy : userId != null ? userId.id : null,
            typeId : typeId != null ? typeId.id : null,
            activePage: activePage ?? 1,
        });
    };

    //QRCode
    const onShowQRCodeShortIO = async (shortUrl) => {
        const resAwsS3 = await AwsS3.getAwsS3();
        if(resAwsS3) {
            setAwsS3Config(resAwsS3);
            setShowModalForm(false);
            setShowModalQRCode(true);
            setShortIOUrl(shortUrl);
        }
    };
    //End

    return (
        <main><Toaster position="bottom-right" />
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Generate UTM</div>
                    <span className="ms-1">/</span> <span className="text-muted">Listing</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                    {roles.isCreate(Utils.MENU_UTM_GENERATE) ? (
                        <NavLink className="btn btn-sm btn-primary" to='/utmGenerate/createSingle'><span><Icon.PlusLg/> สร้าง URL Single</span></NavLink>
                    ) : ''}
                    {roles.isCreate(Utils.MENU_UTM_GENERATE) ? (
                        <NavLink className="btn btn-sm btn-primary ms-2" to='/utmGenerate/createMultiple'><span><Icon.PlusLg/> สร้าง URL Group</span></NavLink>
                    ) : ''}
                    {roles.isCreate(Utils.MENU_UTM_GENERATE) ? (
                        <NavLink className="btn btn-sm btn-success ms-2" to='/utmGenerate/import'><span><Icon.FileExcel/> นำเข้า URL</span></NavLink>
                    ) : ''}
                </div>
            </div>
            {isLoading ? (<span className="spinner-grow spinner-grow-sm"></span>) :
            <>
                <div className="bg-light border rounded my-2">
                    <button type="button" className="btn btn-light w-100 text-start" onClick={() => {setShowSearch(!showSearch)}}><Icon.Search/> ค้นหา | เรียงลำดับ</button>
                    <div className={showSearch ? 'd-block p-3':'d-none'}>
                        <form className="row g-3" onSubmit={onSearch} onReset={onSearchReset}>
                            <div className="col-12 col-sm-6">
                                <label htmlFor="createdBy" className="form-label">Created By</label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    options={users}
                                    onChange={(event) => onChangeUsers(event)}
                                    defaultValue={userId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.contact}`}
                                />
                            </div>
                            <div className="col-12 col-sm-6">
                                <label htmlFor="typeId" className="form-label">Type</label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    options={type}
                                    onChange={(event) => onChangeType(event)}
                                    defaultValue={typeId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className="col-12 col-sm-6">
                                <label htmlFor="name" className="form-label">Start Date</label>
                                <DatePicker
                                    selected={startDate}
                                    onChange={(date) => onChangeStartDate(date)}
                                    startDate={startDate}
                                    endDate={endDate}
                                    dateFormat="yyyy-MM-dd"
                                    wrapperClassName="w-100"
                                    className="form-control w-100" />
                            </div>
                            <div className="col-12 col-sm-6">
                                <label htmlFor="name" className="form-label">End Date</label>
                                <DatePicker
                                    selected={endDate}
                                    onChange={(date) => onChangeEndDate(date)}
                                    startDate={startDate}
                                    endDate={endDate}
                                    minDate={startDate}
                                    dateFormat="yyyy-MM-dd"
                                    wrapperClassName="w-100"
                                    className="form-control" />
                            </div>
                            <div className="col-12 col-sm-6">
                                <label htmlFor="param" className="form-label">URL</label>
                                <input type="text" className="form-control" id="param" value={param ?? ''} onChange={(event) => onChangeParam(event.target.value)}  maxLength={100} />
                            </div>
                            <div className="col-12">
                                <button type="submit" className="btn btn-primary">{isLoading ? btnTextLoading : btnTextDefault}</button>
                                <button type="reset" className="btn btn-light border ms-2">รีเซ็ต</button>
                            </div>
                        </form>
                    </div>
                </div>
                {data.length <= 0 ? (<p>ไม่พบข้อมูล</p>) :
                    <>
                        <button type="button" className={"btn btn-success py-1 my-2" + (checkedIds.length > 0 ? '':' d-none')} onClick={() => onExportSelected()}>Export Selected</button>
                        <div className="table-container shadow">
                        <table className="table table-striped">
                            <thead>
                            <tr>
                                <th className="w50 text-center">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" id="checkAll" onChange={e => {onCheckAll(e.target.checked)}} />
                                        <label className="form-check-label" htmlFor="checkAll"></label>
                                    </div>
                                </th>
                                <th className="w50">ID</th>
                                <th className="w100">Type</th>
                                <th>URL</th>
                                <th className="w70 text-center">Full URL</th>
                                <th className="w90 text-center">Rebrandly</th>
                                <th className="w150 text-center">Short.io</th>
                                <th className="w80 text-center">Duplicate</th>
                                <th className="w100 text-center">CreatedBy</th>
                                <th className="w100 text-center">Created Date</th>
                                {roles.isDelete(Utils.MENU_UTM_GENERATE) ? (
                                    <th className="w70 text-center">ลบ</th>
                                ) : ''}
                            </tr>
                            </thead>
                            <tbody>
                            {data.map((row, index) => {
                                let fullUrl = row.url+'?'+row.params + (row.addLine ? '#addline':'');
                                return (
                                    <tr key={index} id={"rowId" + row.id}>
                                        <th className="text-center">
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" id={"checkId"+row.id} value={row.id} onClick={() => onCheckedItem()} />
                                                <label className="form-check-label" htmlFor={"checkId"+row.id} ></label>
                                            </div>
                                        </th>
                                        <td>{row.id}</td>
                                        <td>{Utils.generateUTMType(row.typeId)}</td>
                                        <td>
                                            <div className="noselect-url">{fullUrl}</div>
                                        </td>
                                        <td className="text-center">
                                            <CopyToClipboard text={fullUrl} onCopy={() => {onCopyFullUrl()}}>
                                                <button type="button" className={row.params && row.url ? 'btn btn-sm btn-light' : 'btn btn-sm btn-light d-none'} title="คัดลอก Full URL"><Icon.Files /></button>
                                            </CopyToClipboard>
                                        </td>
                                        <td className="text-center">
                                            {
                                                row.shortUrl ? <CopyToClipboard text={"https://" + row.shortUrl} onCopy={() => {onCopyRebrandlyUrl()}}>
                                                    <button type="button" className="btn btn-sm btn-light" title={"คัดลอก Short URL : " + row.shortUrl}><Icon.Link45deg /></button>
                                                </CopyToClipboard> : ''
                                            }

                                        </td>
                                        <td className="text-center">
                                            {
                                                row.shortIO && shortio.domain ?
                                                    <>
                                                        <CopyToClipboard text={"https://" + shortio.domain + '/' + row.shortIO} onCopy={() => {onCopyShortIOUrl()}}>
                                                            <button type="button" className="btn btn-sm btn-light" title={"คัดลอก Short URL : " + "https://" + shortio.domain + '/' + row.shortIO}><Icon.Link45deg /></button>
                                                        </CopyToClipboard>
                                                        {
                                                            roles.isEdit(Utils.MENU_SHORTIO) ? <button type="button" className="btn btn-sm btn-light ms-1" title={"แก้ไข Short URL : " + "https://" + shortio.domain + '/' + row.shortIO} onClick={ () => onEditShortIO(row)}><Icon.Pencil /></button> : ''
                                                        }
                                                        {
                                                            qrcodeLogo !== null && qrcodeLogo.length > 0 ? <button type="button" className="btn btn-sm btn-light ms-1" title="แสดง QR Code" onClick={ () => onShowQRCodeShortIO("https://" + shortio.domain + '/' + row.shortIO)}><Icon.QrCode /></button> : ''
                                                        }
                                                    </>
                                                    : ''
                                            }
                                        </td>
                                        <td className="text-center">
                                            {roles.isCreate(Utils.MENU_UTM_GENERATE) ? (
                                                <Link className="btn btn-sm btn-light mx-1" to={'/utmGenerate/duplicate/' + Utils.encodeItem({id: row.id,  createdAt: row.createdAt})}><Icon.Send/></Link>
                                            ) : ''}
                                        </td>
                                        <td className="text-center small">{row.user && row.user.contact ? row.user.contact : ''}</td>
                                        <td className="text-center">{Utils.dateTime(row.createdAt)}</td>
                                            {roles.isDelete(Utils.MENU_UTM_GENERATE) ? (
                                                <td className="text-center"><button className="btn btn-sm btn-light mx-1" onClick={() => Utils.deleteItem('utmGenerate', row.id, row.params)}><Icon.Trash/></button></td>
                                            ) : ''}
                                    </tr>
                                );
                            })
                            }
                            </tbody>
                        </table>
                        </div>
                        <div className="row mt-3">
                            <div className="col-12 col-sm-4 mt-2 mt-sm-0 text-end align-self-center">
                                <select className="form-select w100" id="itemPerpage" onChange={(e) => onChangeItemPerpage(e)} value={itemPerpage}>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                            <div className="col-12 col-sm-8">
                                <div className={totalPage > 1 ? 'my-3':'d-none'}>
                                    <Pagination
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        innerClass="pagination justify-content-sm-end"
                                        activePage={activePage}
                                        itemsCountPerPage={itemPerpage}
                                        totalItemsCount={countAllItem}
                                        pageRangeDisplayed={5}
                                        onChange={(pageNum) => onPageChange(pageNum)}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                }

                {
                    showModalForm && <ModalShortIO data={shortIOData} handleModalClose={handleModalClose} handleModalFormUpdate={handleModalFormUpdate} />
                }

                {
                    showModalQRCode && <ModalQRCode shortIOUrl={shortIOUrl} qrcodeLogo={qrcodeLogo} awsS3Config={awsS3Config} handleModalClose={handleModalClose} />
                }
            </>
            }
        </main>
    );
} 